import styled from 'styled-components';
import { desktop_breakpoint_extended } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const CCPARequestStyles = styled.div`
  h1 {
    text-align: center;
  }

  @media only screen and (min-width: ${desktop_breakpoint_extended}px) {
    .ccpa-body {
      margin: 0 auto;
      max-width: 996px; /* 1024px - 30px margin */
      padding-top: 85px;
    }
  }
`;

export default CCPARequestStyles;
